import { Component } from '@angular/core';

@Component({
  selector: 'app-confirmed-membership',
  templateUrl: './confirmed-membership.component.html',
  styleUrls: ['./confirmed-membership.component.scss'],
})
/**
 * Confirms business representative change
 */
export class ConfirmedMembershipComponent {}
